import { PlusIcon } from '@buffer-mono/popcorn'

import { useChannelsConnected } from '~publish/contexts/AccountContext'

import { TaskCard } from './TaskCard'
import { BUFFER_HOME_TASK_STATUS } from './useBufferHomeChecklist'
import { useConnectChannelStatus } from './useTaskCardStatus'

import type { JSX } from 'react'

const CONNECT_CHANNEL_CTA = 'publish-home-firstSteps-connectChannel-1'

export function ConnectChannelCard(): JSX.Element {
  const { status, markComplete } = useConnectChannelStatus()
  const channels = useChannelsConnected()
  // Once the task is server-completed, leave the button alone — disabling only
  // gates the pending → complete transition.
  const isPending = status === BUFFER_HOME_TASK_STATUS.Pending
  const canMarkComplete = !isPending || channels.length > 0

  const handleConnectChannel = (): void => {
    window?.appshell?.actions?.openChannelStorefront({
      cta: CONNECT_CHANNEL_CTA,
    })
  }

  return (
    <TaskCard status={status}>
      <TaskCard.CompleteAction
        onClick={markComplete}
        disabled={!canMarkComplete}
        disabledReason="Connect a channel to mark this done"
      />
      <TaskCard.Header>
        <TaskCard.Title>1. Connect a channel</TaskCard.Title>
      </TaskCard.Header>
      <TaskCard.Description>
        Personalize your profile to make the most out of Buffer.
      </TaskCard.Description>
      <TaskCard.Footer>
        <TaskCard.PrimaryAction onClick={handleConnectChannel}>
          <PlusIcon />
          Connect Channel
        </TaskCard.PrimaryAction>
        <TaskCard.CompletedLabel>
          First Channel Connected
        </TaskCard.CompletedLabel>
      </TaskCard.Footer>
    </TaskCard>
  )
}
